export const AVISO_PRIVACIDAD = 'https://cors-anywhere.herokuapp.com/https://a3cloud-qa.s3-us-west-2.amazonaws.com/microservices/MiFirma/assets/docs/AVISO+DE+PRIVACIDAD+A3+SERVICIOS+DE+TECNOLOGIA+SA+DE+CV+131020.pdf'
